var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMissing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#A1A5B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.363 4.53665C18.657 3.82112 17.5124 3.82112 16.8064 4.53665L11.981 9.42746L7.11003 4.63285C6.39369 3.92774 5.23787 3.93337 4.52843 4.64544C3.819 5.35751 3.8246 6.50636 4.54094 7.21148L9.42454 12.0185L4.63575 16.8722C3.92979 17.5877 3.92979 18.7478 4.63575 19.4634C5.34172 20.1789 6.48632 20.1789 7.19229 19.4634L12.0185 14.5718L16.89 19.367C17.6063 20.0721 18.7621 20.0664 19.4716 19.3544C20.181 18.6423 20.1754 17.4934 19.4591 16.7883L14.5749 11.9807L19.363 7.12781C20.0689 6.41228 20.0689 5.25218 19.363 4.53665Z",
    fill: "#D62323"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/missing.c05424e3.svg";
export { ForwardRef as ReactComponent };